import { createFileRoute } from '@tanstack/react-router'
import { PhotoGalleryPage } from '_/features/pets/ui/pages/photo-gallery-page'

const PhotoGalleryRoute = () => {
	const { petId } = Route.useParams()
	return <PhotoGalleryPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/photos')({
	staticData: { title: 'photos_title' },
	component: PhotoGalleryRoute,
})
